module.exports = __webpack_public_path__ + "img/info-image.030f276d.jpg";